import { useQuery } from "@tanstack/react-query";
import { useLogbookSettings } from "../../../context/LogbookSettingsContext";
import type { TopSection } from "../models/Section";
import { getTopUsedSections } from "../repositories/SectionRepository";

type UseTopSectionsProps = {
	top?: number;
};

export const useTopSections = ({ top = 5 }: UseTopSectionsProps = {}) => {
	const { section } = useLogbookSettings();
	const schema = section?.schema;

	return useQuery<TopSection[], Error>({
		queryKey: ["topSections", schema, top],
		queryFn: ({ signal }) => getTopUsedSections({ schema, top, signal }),
	});
};
